import React from 'react';

export default function BannerOverlay(props) {
	const text = props.text

    if (text == null) {
        return null;
    }

    return (
        <div className="xs_bannerOddsOverlay h-10 grid grid-cols-12 p-1 bg-gradient-to-b from-shadow-start to-shadow-end rounded-b-lg">
            <div className="col-start-1 col-end-12 flex flex-col align-center justify-evenly">
                <span className="text-fs1 font-medium uppercase text-shadow-contrast-1 overflow-hidden">{text}</span>
            </div>
        </div>
    );
}
